/*
 * Model for substitution search box
 */

define(["backbone"], function (Backbone) {
  var SubstitutionSearchModel = {};

  SubstitutionSearchModel.substitutionSearchModel = Backbone.Model.extend({
    defaults: {
      search: false,
      noResults: false,
      filterByEntry: true,
    },
  });

  return SubstitutionSearchModel;
});
